import React from 'react';
import styled from 'styled-components';

import { Input } from '../element';
import { TextAreaProps } from './types';

const Container = styled.div`
  position: relative;
`;

const LimitLabel = styled.div`
  color: #909399;
  background: #fff;
  position: absolute;
  font-size: 12px;
  bottom: 5px;
  right: 10px;
`;

export const TextArea: React.FC<TextAreaProps> = ({ wordLimit = false, ...props }) => {
  const { maxLength, value = '' } = props;

  return (
    <Container>
      <Input type="textarea" {...props} />

      {wordLimit && maxLength && (
        <LimitLabel>
          {String(value).length}/{maxLength}
        </LimitLabel>
      )}
    </Container>
  );
};
